module.exports = __webpack_public_path__ + "static/mia-graphic-designer-a1ee881c72977b8933b2e713ba01c04c.png";